<div class="tabs-1" [class.tabs-2]="isTab">
	<em class="material-icons" [hidden]="isTab" (click)="isTab=true">tablet</em>
	<em class="material-icons" [hidden]="!isTab" (click)="isTab=false">smartphone</em>
	<div class="preview_phone" [class.preview_tab]="isTab">
		<iframe id="iframeMain" SameSite=None #iframeMain width="100%" height="100%" style="border: none;"
			[src]="iframe_html" (load)="onload($event)" [height]="iframeHeight"></iframe>
	</div>
</div>